// @flow

import React from 'react'
import styled, { css } from 'styled-components'

const Container = styled.div`
  display: inline-block;
  width: 100%;
  ${({ width }) => css`
    max-width: ${width || '100%'};
  `};
`

export type PropTypes = {
  width?: '140px' | '300px' | '100%',
  children: any,
}

export default (props: PropTypes) => (
  <Container width={props.width}>{props.children}</Container>
)



// WEBPACK FOOTER //
// ./src/components/molecules/InputContainer/index.jsx